"use strict";
import i from "./index.es119.js";
import a from "./index.es120.js";
import e from "./index.es121.js";
import n from "./index.es122.js";
import l from "./index.es123.js";
import s from "./index.es124.js";
import u from "./index.es125.js";
import c from "./index.es126.js";
import d from "./index.es127.js";
import { VERSION as C } from "./index.es128.js";
import x from "./index.es129.js";
import A from "./index.es130.js";
import E from "./index.es131.js";
import y from "./index.es132.js";
import O from "./index.es133.js";
import g from "./index.es134.js";
import w from "./index.es135.js";
function p(o) {
  const m = new e(o), t = a(e.prototype.request, m);
  return i.extend(t, e.prototype, m, { allOwnKeys: !0 }), i.extend(t, m, null, { allOwnKeys: !0 }), t.create = function(f) {
    return p(n(o, f));
  }, t;
}
const r = p(l);
r.Axios = e;
r.CanceledError = u;
r.CancelToken = c;
r.isCancel = d;
r.VERSION = C;
r.toFormData = x;
r.AxiosError = A;
r.Cancel = r.CanceledError;
r.all = function(o) {
  return Promise.all(o);
};
r.spread = E;
r.isAxiosError = y;
r.mergeConfig = n;
r.AxiosHeaders = O;
r.formToJSON = (o) => s(i.isHTMLForm(o) ? new FormData(o) : o);
r.getAdapter = g.getAdapter;
r.HttpStatusCode = w;
r.default = r;
export {
  r as default
};
//# sourceMappingURL=index.es26.js.map
